import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Extract city/locality from a full address string.
 * Assumes format: "Street, City, State ZIP" or similar patterns.
 */
export function extractCityFromAddress(address: string | null | undefined): string | null {
  if (!address) return null
  const parts = address.split(',').map((p) => p.trim())
  // City is typically the second part (after street address)
  if (parts.length >= 2) {
    return parts[1]
  }
  return null
}

/**
 * Get display label for a location.
 * Uses display_name if set, otherwise name, with optional city suffix.
 */
export function getLocationLabel(location: {
  name: string
  display_name?: string | null
  address?: string | null
}): string {
  const name = location.display_name || location.name
  const city = extractCityFromAddress(location.address)
  return city ? `${name} - ${city}` : name
}
